module.exports = __webpack_public_path__ + "img/small-7.5d7af4b2.jpg";